import { useSelector } from 'react-redux';
import {
  selectUser,
} from './userSlice';

export const useUser = () => {
  const { body, updating, lyfshortUser } = useSelector(selectUser);

  return {
    body,
    updating,
    lyfshortUser,
  };
};
